import { render, staticRenderFns } from "./Hobby.vue?vue&type=template&id=02c13fc7&scoped=true&"
import script from "./Hobby.vue?vue&type=script&lang=js&"
export * from "./Hobby.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c13fc7",
  null
  
)

export default component.exports